import { CMSArticle } from "@nju/feature-portal-help";

export function CookiesDetails() {
  return <CMSArticle categoryId="NJU_WWW_COOKIES" />;
}
